module.exports = __webpack_public_path__ + "images/tr_wework/ic-success@2x-b05de99e91915a2f509a9d50423651d5.png";